export const filterLists = data => {
  return {
    infrastructureList: Object.entries(data.infrastructure || {}),
    paymentsTypeList: Object.entries(data.payments_types || {}),
    whatToTakeList: Object.entries(data.what_to_take || {}),
    whatIsIncludedList: Object.entries(data.what_is_included || {})
  }
}
